import React from "react";
import { DetailRow, DetailSection } from "../../../components/ui/detailView";
import { useTranslation } from "react-i18next";

interface InvoicePartyProps {
  title: string;
  name: string;
  street?: string;
  zipCode?: string;
  city?: string;
  /** Tax identifier, already prefixed when it isn't a NIP. */
  identifier?: React.ReactNode;
  identifierLabel?: string;
  children?: React.ReactNode;
}

/** One side of an invoice (seller, buyer, receiver) as a detail section. */
export const InvoiceParty = ({
  title,
  name,
  street,
  zipCode,
  city,
  identifier,
  identifierLabel,
  children,
}: InvoicePartyProps) => {
  const { t } = useTranslation();
  const hasAddress = street !== undefined || zipCode !== undefined || city !== undefined;
  const cityLine = [zipCode, city].filter(Boolean).join(" ");

  return (
    <DetailSection title={title}>
      <DetailRow label={t("Name")} value={name} />
      {hasAddress && (
        <DetailRow label={t("Address")} multiline value={[street, cityLine].filter(Boolean).join("\n")} />
      )}
      <DetailRow label={identifierLabel ?? t("NIP")} value={identifier} />
      {children}
    </DetailSection>
  );
};
